
/***
*
*    pinia在main.js里引入 
* 
*              import { createPinia } from 'pinia'
* 
*              import plugin from './store/plugin.js'
*
*              const pinin = createPinia()
*
*              pinin.use(plugin)
*
*
***/ 

const KEY_PREFIX = 'PINIA_STORE_'

export default function(context) {
	

	const {
		store
	} = context
	
	// store.$id defineStore 会有多个，动态拼接

	const KEY = KEY_PREFIX + store.$id


	// 保存仓库数据到本地

	window.addEventListener('beforeunload', () => {

		sessionStorage.setItem(KEY, JSON.stringify(store.$state))
	})

	// 恢复数据
	try{
		
		const localData = sessionStorage.getItem(KEY);
		
		if(localData){
			store.$patch(JSON.parse(localData))
		}
		
	}catch(e){
		// console.log('本地存储异常')
	}
}







